/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    INVENTORY_PAGE_SPLIT_UTILS
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted utility functions and constants from InventoryPage.tsx.
 *
 * File Size Check:
 * - Current: ~50 lines
 * - Target: <150 lines
 * - Decision: Split completed
 */

import { InventoryMeta } from "../types";

export const MAX_ROWS_PER_JOB = 100000;
export const MAX_ROWS_PER_CHUNK = 1000;

export const mockMeta: InventoryMeta = {
  categories: [
    "Drones/UAV",
    "Motors & Props",
    "Cameras & Gimbals",
    "Batteries",
    "GCS – Ground Control Systems",
    "Storage",
    "Components",
    "Software",
    "C-UAS",
    "Services",
    "Other",
  ],
  conditions: ["NEW Retail", "New Bulk", "Refurbished", "Used", "AS-IS"],
  countries: ["US", "UK", "DE", "FR", "CA", "AU"],
  manufacturers: ["DJI", "Parrot", "Autel", "Yuneec", "Skydio", "Intel"],
};
